module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Medium.fb9b9cc0.otf";